import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import { useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router';

import { getPackageOptions } from '@drivingdoc/api-client/generated/react-query';
import { GetPackageResult } from 'types/packages';

import { PageContainer } from 'components/PageContainer';

import useSearchParamState from 'hooks/useSearchParamState';

import PackageCourseList from './Tabs/PackageCourseList';
import WelcomeLetter from './Tabs/WelcomeLetter';
import PackageTerms from './Tabs/PackageTerms';

type PackageTabs = 'courses' | 'welcome_letter' | 'terms';

export function ManagePackage() {
  // get the package id
  const { id } = useParams<{ id: string }>();
  const [tabValue, setTabValue] = useSearchParamState({
    paramName: 'tab',
    initialState: 'courses',
    serialize: String,
    deserialize: String,
  });

  // fetch the package
  const pkg = useQuery({
    ...getPackageOptions({
      path: {
        id: id ?? '',
      },
    }),
    enabled: !!id,
  });
  const packageData = pkg.data as GetPackageResult | undefined;

  const handleSetTabValue = (_event: React.SyntheticEvent, newValue: PackageTabs) => {
    setTabValue(newValue);
  };

  return (
    <PageContainer title={packageData?.name}>
      <Tabs
        value={tabValue}
        onChange={handleSetTabValue}
        sx={{
          background: 'transparent',
          ml: -2,
          marginBottom: 2,
        }}
      >
        <Tab value="courses" label="Courses" />
        <Tab value="welcome_letter" label="Welcome Letter" />
        <Tab value="terms" label="Package Terms" />
      </Tabs>

      {id && tabValue === 'courses' && <PackageCourseList packageId={id} />}
      {id && tabValue === 'welcome_letter' && <WelcomeLetter packageId={id} />}
      {id && tabValue === 'terms' && <PackageTerms packageId={id} />}
    </PageContainer>
  );
}

export default ManagePackage;
